import { getConfig, getConfigValueOrThrow } from '../config';
import { emitEvent } from '../utils/events/module';
import { clearCurrentSession } from './cache';
import { refreshSession } from './module';
/**
 * Token refresh timeout
 */
let refreshTimer;
/**
 * Token expire timeout
 */
let expiryTimer;
export function setTimers() {
    // Default autoRefresh to true if it's not defined
    const autoRefresh = getConfig().AUTH_AUTO_REFRESH !== false;
    if (refreshTimer) {
        clearTimeout(refreshTimer);
    }
    if (autoRefresh) {
        refreshTimer = setTimeout(() => {
            refreshSession();
        }, getConfigValueOrThrow('AUTH_EXPIRY_MS'));
    }
    // Set timeout for when session expires
    expiryTimer && clearTimeout(expiryTimer);
    expiryTimer = setTimeout(() => {
        clearCurrentSession();
        emitEvent('session', 'expired');
    }, 
    // 10 seconds after it should have been refreshed
    // That should be enough time to make the API call and reset this timer
    getConfigValueOrThrow('AUTH_EXPIRY_MS') + 10 * 1000);
}
export function clearTimers() {
    if (refreshTimer) {
        clearTimeout(refreshTimer);
    }
    if (expiryTimer) {
        clearTimeout(expiryTimer);
    }
}
